/**
 * Splash Card
 * @author PBirudukota
 * @description Used in Landing Page and Confirmation Page
 */
import {Component, Input, OnInit, OnDestroy, AfterContentChecked} from '@angular/core';
import {MessagesService} from '../../services/messages.service';
import {ActivatedRoute, Router, NavigationExtras} from '@angular/router';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import { Subscription } from 'rxjs';
import { SalesrefService } from 'src/app/services/salesref.service';
import { AppDataService } from 'src/app/services/app-data.service';

@Component({
  selector: 'app-splash-card',
  templateUrl: './splash-card.component.html',
  styleUrls: ['./splash-card.component.css']
})
export class SplashCardComponent implements OnInit, OnDestroy, AfterContentChecked {

  @Input() title: string;
  @Input() header: string;
  @Input() subHeader: string;
  @Input() enableActions: boolean;
  currentYear: string = new Date().getFullYear().toString();
  message: any;
  country: any;
  customer: any;
  customerSelectionForm: FormGroup;
  isShow = true;
  isExisting = false;
  customerType: string;
  subscription: Subscription;
  optionsPreset= false;
  openModal = false;
  modalCopy = `Thank you for your interest in partnering with ATD. Unfortunately, we weren’t able to verify your application link. If an ATD associate provided you with this link, please contact them directly for additional support. Otherwise, please visit <a href='https://www.atd-us.com'> ATD-US.com </a> and complete the “Partner With Us” form to get started.`
  copySet = false;

  constructor(private messagesService: MessagesService,
    private salesRefService: SalesrefService,
    private appDataService: AppDataService,
    private router: Router) {
  }

  ngOnInit(): void {
    (<HTMLInputElement>document.getElementById("begin")).disabled = true;
   
    this.messagesService.getConfMessage().subscribe(message => {
      this.message = message;

    });

    this.customerSelectionForm = new FormGroup({
      COUNTRY_SELECTION: new FormControl(null),
      CUSTOMER_SELECTION: new FormControl(null, [Validators.required]),
    });

    this.onCustomerTypeChanges();
  }

  ngAfterContentChecked(): void {
    if ((this.appDataService.appData.isValid === true) && (this.copySet === false)) {
      this.redirectToNewUrl()
      this.modalCopy= this.appDataService.appData.value;
      this.copySet = true;
    }

    if ((this.salesRefService.refinfo.code !== 0) && (this.salesRefService.refinfo.isValid === false) && (this.optionsPreset === false)) {
      this.redirectToNewUrl();
      this.openModal = true;
      this.optionsPreset = true;
    }
    if (this.salesRefService.refinfo.isValid && !this.optionsPreset) {
      this.redirectToNewUrl();
      this.customerSelectionForm.setValue({"CUSTOMER_SELECTION": "newcustomer", "COUNTRY_SELECTION": "UNITED_STATES"});
      this.optionsPreset = true;
    }
  }

  onCustomerTypeChanges() {
    this.subscription = this.customerSelectionForm.get('CUSTOMER_SELECTION').valueChanges.subscribe(val => {
      this.customerType = val;
      if ((val === "existingcustomer") || (val === "newcustomer" && this.salesRefService.refinfo.isValid)) {
        (<HTMLInputElement>document.getElementById("begin")).disabled = false;
      }
      else {
        (<HTMLInputElement>document.getElementById("begin")).disabled = true;
      }
      if ((val === "newcustomer") && (this.salesRefService.refinfo.isValid === false)) {
       this.customerSelectionForm.reset();
       this.redirectToNewUrl();
      }
    });
  }

  toggleDisplay(e) {
    if (e.CUSTOMER_SELECTION !== undefined && e.COUNTRY_SELECTION !== undefined) {
      this.isShow = !this.isShow;
      this.toggleButton();
  } else {
    this.unfilledRadioCheck();
  }
}

unfilledRadioCheck() {
  this.customerSelectionForm.setErrors({
    unfilledRadioButton: true
  });
}

redirectToNewUrl() {
  const envUrl = window.location.href;  
    if(envUrl.includes('localhost') || envUrl.includes('qa')) {
      window.location.href = 'https://americantiredistributorsdev.service-now.com/atd';
    } else if(envUrl.includes('test')) {
      window.location.href = 'https://americantiredistributorstest.service-now.com/atd';
    } else {
      window.location.href = 'https://customer.atd-us.com';
    }
}

clickModal() {
  this.openModal = !this.openModal;
}

  toggleButton() {
    const button = document.getElementById('upload');
    if (!this.isShow) {
      button.classList.add('button-background');
    } else {
      button.classList.remove('button-background');
    }
  }

  begin(e) {
      if (e.CUSTOMER_SELECTION !== undefined && e.COUNTRY_SELECTION !== undefined) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          country: this.country,
          customer: this.customer
        }
      };
      if (this.customer === 'newcustomer') {
        const payload: any = {
          country: this.country,
          customer: this.customer
        };
        this.router.navigate(['/application/'], navigationExtras);
      } else {
        this.router.navigate(['/customer/'], navigationExtras);
      }
    } else {
      this.unfilledRadioCheck();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
